var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgActionSmallPhone2TertiaryDefault = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "display/small/custom/phone-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Budget-Details/R2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5858913,2 L9.42875948,2 C8.36052346,2 7.5,2.84481793 7.5,3.89355742 L7.5,26.1064426 C7.5,27.1551821 8.36052346,28 9.42875948,28 L20.5710546,28 C21.6392907,28 22.4998141,27.1551821 22.4998141,26.1064426 L22.4998141,3.89355742 C22.5146507,2.84481793 21.6392907,2 20.5858913,2 Z M21.0606628,23.0621849 L8.95398792,23.0621849 L8.95398792,5.18991597 L21.0606628,5.18991597 L21.0606628,23.0621849 Z M17.5888958,3.92268908 L12.425755,3.92268908 L12.425755,3.36918768 L17.5888958,3.36918768 L17.5888958,3.92268908 L17.5888958,3.92268908 Z M19.7995509,3.67507003 C19.7995509,3.9372549 19.5770017,4.1557423 19.3099427,4.1557423 C19.0428837,4.1557423 18.8203345,3.9372549 18.8203345,3.67507003 C18.8203345,3.41288515 19.0428837,3.19439776 19.3099427,3.19439776 C19.5770017,3.17983193 19.7995509,3.39831933 19.7995509,3.67507003 Z M17.3663466,25.989916 L12.6631408,25.989916 L12.6631408,24.562465 L17.3663466,24.562465 L17.3663466,25.989916 Z",
    id: "Shape-Copy",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActionSmallPhone2TertiaryDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/action-small-phone-2-tertiary-default.38e84ed647b0f8bef92f66b65c60e8c4.svg";